/**
 *
 * Order
 *
 */

import { mapState, mapActions } from 'vuex';
import $ from 'jquery';
import _ from 'lodash';
import Swal from 'sweetalert2';
import QRCode from 'qrcode';
import countdown from 'countdown';
import { swalSuccess, swalWarning } from '@/utils/swal2';
import { getUrlProtocol } from '@/utils/browser';

import TrackerButton from '@/components/TrackerButton.vue';
import SharedHeader from '@/components/SharedHeader.vue';
import SharedFooter from '@/components/SharedFooter.vue';
import Spinner from '@/components/Spinner.vue';
import {
  SERVER_ROOT_DOMAIN,
  URL_WWW_PZ_ACADEMY_COM,
  URL_CLASS_PZ_ACADEMY_COM,
} from '@/constants/index';
import { /* LANDING_PAGE, */ DASHBOARD_PAGE, MALL_CATEGORY_COUPON_PAGE } from '@/constants/routes';
import { MALL_ORDER_PAGE_CHUNK_NAME, MALL_TRADE_PAGE_CHUNK_NAME } from '@/constants/pageChunk';
import { AddressEditContainerMixin } from '@/mixins/AddressEdit/AddressEditContainer';
import { LOADING_MESSAGE } from './Order.constants';
import { OrderWriteOffMixin } from './OrderWriteOff.mixin';

export default {
  name: 'Order',

  mixins: [AddressEditContainerMixin, OrderWriteOffMixin],

  components: {
    SharedHeader,
    SharedFooter,
    Spinner,
    TrackerButton,
  },

  data: () => {
    return {
      URL_WWW_PZ_ACADEMY_COM,
      SERVER_ROOT_DOMAIN,
      loadingMessage: LOADING_MESSAGE,

      //mall_category: '',
      fromwechat: '',
      mpGoodsId: '',

      promiseGetMallCouponList: null,

      ciReadFlag: false,
      ciStep: 1,
      hideFooter: false,
      isAgreedLegal: false,

      encoreDescription1: '',
      encoreDescription2: '',

      referalCode: '',
      referalCodeMoney: '0.00',
      isShowReferalCodeHalfFilled: false,

      //refBenefit: false,
      benefitCode: '',
      benifitCodeMoney: '0.00',
      isInvalidBenefitCode: false,

      payChannel: '',

      checkResult: 0,
      checkResultMessage: '',

      isAgreedDeposit: false,

      qrType: null,
      srcPayQR: '',

      toCheckPage: false,
      checkStatus: 0,
      isCheckStatusShouldSetTo2: false,
      count: 1,
      scanLoop: null,

      fq: 0,

      paplTimerPromiseHide: null,
      paplTimerPromise: null,
      paplQueue: [],
      paplSubmitting: false,

      timeSpan: null,
      countdownId: null,

      player: null,

      payType: '',

      itvlLegal: null,
    };
  },

  computed: {
    ...mapState({
      ms_isDebug: 'isDebug',
    }),

    ...mapState('Mall/Order', {
      ms_checkResult: 'checkResult',
      ms_checkResultMessage: 'checkResultMessage',
      ms_imgQr: 'imgQr',
      ms_checkScanResult: 'checkScanResult',
      ms_paypalURL: 'paypalURL',
      ms_webAlipayPageSnapletHtml: 'webAlipayPageSnapletHtml',
      ms_webHaierUrl: 'webHaierUrl',
      ms_couponList: 'couponList',
      ms_isRequestCheck: 'isRequestCheck',
      ms_isRequestCouponList: 'isRequestCouponList',
    }),

    ...mapState('Mixins/Setting', {
      ms_setting_mixin_isRequest: 'isRequest',
    }),

    c_isOrderPage() {
      return MALL_ORDER_PAGE_CHUNK_NAME === this.$route.name;
    },

    c_isTradePage() {
      return MALL_TRADE_PAGE_CHUNK_NAME === this.$route.name;
    },

    c_tradeType() {
      if (this.c_isTradePage) {
        return this.$route.params.tradeType;
      } else {
        return '';
      }
    },

    c_isNormalTradePage() {
      return this.c_isTradePage && 'normal' === this.c_tradeType;
    },

    c_isLockpriceDepositTradePage() {
      return this.c_isTradePage && 'lockprice-deposit' === this.c_tradeType;
    },

    c_isLockpriceBalanceTradePage() {
      return this.c_isTradePage && 'lockprice-balance' === this.c_tradeType;
    },

    c_isLockpriceTradePage() {
      return this.c_isLockpriceDepositTradePage || this.c_isLockpriceBalanceTradePage;
    },

    c_isPresellDepositTradePage() {
      return this.c_isTradePage && 'presell-deposit' === this.c_tradeType;
    },

    c_isPresellBalanceTradePage() {
      return this.c_isTradePage && 'presell-balance' === this.c_tradeType;
    },

    c_isDepositTradePage() {
      return this.c_isLockpriceDepositTradePage || this.c_isPresellDepositTradePage;
    },

    c_isBalanceTradePage() {
      return this.c_isLockpriceBalanceTradePage || this.c_isPresellBalanceTradePage;
    },

    c_isPresellTradePage() {
      return this.c_isPresellDepositTradePage || this.c_isPresellBalanceTradePage;
    },

    c_isLockpricePresellTradePage() {
      return this.c_isLockpriceTradePage || this.c_isPresellTradePage;
    },

    c_tradeId() {
      if (this.c_isTradePage) {
        return this.$route.params.tradeId;
      } else {
        return '';
      }
    },

    c_isShowSpinner() {
      return this.ms_isRequest || this.ms_setting_mixin_isRequest;
    },

    c_isFromChannel() {
      return this.$route.query.source && 700 < Number(this.$route.query.source);
    },

    c_limitYear() {
      return this.$route.query.limitYear ? parseInt(this.$route.query.limitYear) : 0;
    },

    c_vendor_oid() {
      return this.$route.query.vendor_oid ? this.$route.query.vendor_oid : undefined;
    },

    c_param4StudentId() {
      return this.$route.query.param4 ? this.$route.query.param4 : undefined;
    },

    c_channelId() {
      return this.$route.query.param5 ? this.$route.query.param5 : undefined;
    },

    c_surveyFormId() {
      return this.$route.query.surveyFormId ? this.$route.query.surveyFormId : undefined;
    },

    c_isActivity() {
      return 5 === this.ms_order.category && this.ms_order.activityUrl;
    },

    c_isGoodActivity() {
      return this.ms_order.activity ? true : false;
    },

    c_goodActivity() {
      if (this.c_isGoodActivity) {
        return this.ms_order.activity;
      } else {
        return undefined;
      }
    },

    c_isGoodActivityRefund() {
      return this.c_isGoodActivity && this.c_goodActivity.refund;
    },

    c_isGoodActivityPresell() {
      return this.c_isGoodActivity && 5 === this.c_goodActivity.activityType;
    },

    c_isOnSell() {
      return this.ms_order.onSell || this.c_isGoodActivityPresell;
    },

    c_isPresellOrderPage() {
      return this.c_isOrderPage && this.c_isGoodActivityPresell;
    },

    c_isLockpriceDepositPage() {
      return this.c_isLockpriceDepositTradePage;
    },

    c_isPresellDepositPage() {
      return this.c_isPresellOrderPage || this.c_isPresellDepositTradePage;
    },

    c_isDepositPage() {
      return this.c_isLockpriceDepositPage || this.c_isPresellDepositPage;
    },

    c_isBalancePage() {
      return this.c_isBalanceTradePage;
    },

    c_isLockpricePresellPage() {
      return this.c_isPresellOrderPage || this.c_isLockpricePresellTradePage;
    },

    c_depositAndBalanceModel() {
      return this.ms_order.depositAndBalanceModel ? this.ms_order.depositAndBalanceModel : {};
    },

    c_depositPrice() {
      if (this.c_isPresellOrderPage) {
        return this.c_goodActivity.depositPrice;
      } else if (this.c_isLockpricePresellTradePage) {
        return this.c_depositAndBalanceModel.deposit;
      }
      return undefined;
    },

    c_depositPriceString() {
      if (this.c_isPresellOrderPage) {
        return this.c_goodActivity.depositPriceString;
      } else if (this.c_isLockpricePresellTradePage) {
        return this.c_depositAndBalanceModel.depositString;
      }
      return undefined;
    },

    c_balancePrice() {
      if (this.c_isPresellOrderPage) {
        return this.c_goodActivity.balancePrice;
      } else if (this.c_isLockpricePresellTradePage) {
        return this.c_depositAndBalanceModel.duePrice;
      }
      return undefined;
    },

    c_balancePriceString() {
      if (this.c_isPresellOrderPage) {
        return this.c_goodActivity.balancePriceString;
      } else if (this.c_isLockpricePresellTradePage) {
        return this.c_depositAndBalanceModel.duePriceString;
      }
      return undefined;
    },

    c_dueStartTime() {
      if (this.c_isPresellOrderPage) {
        return this.c_goodActivity.dueStart;
      } else if (this.c_isLockpricePresellTradePage) {
        return this.c_depositAndBalanceModel.dueStartTime;
      }
      return undefined;
    },

    c_objStrDueStartTime() {
      if (this.c_dueStartTime) {
        return this.getObjStrDueTime(this.c_dueStartTime);
      } else {
        return {};
      }
    },

    c_dueEndTime() {
      if (this.c_isPresellOrderPage) {
        return this.c_goodActivity.dueEnd;
      } else if (this.c_isLockpricePresellTradePage) {
        return this.c_depositAndBalanceModel.dueEndTime;
      }
      return undefined;
    },

    c_objStrDueEndTime() {
      if (this.c_dueEndTime) {
        return this.getObjStrDueTime(this.c_dueEndTime);
      } else {
        return {};
      }
    },

    c_labelDueTime() {
      let labelDueTime = '';
      if (this.c_dueStartTime && this.c_dueEndTime) {
        labelDueTime += `${this.c_objStrDueStartTime.strDueYear}年`;
        labelDueTime += `${this.c_objStrDueStartTime.strDueMonth}月`;
        labelDueTime += `${this.c_objStrDueStartTime.strDueDate}日`;
        labelDueTime += `${this.c_objStrDueStartTime.strDueHour}:`;
        labelDueTime += `${this.c_objStrDueStartTime.strDueMinute} - `;
        labelDueTime += `${this.c_objStrDueEndTime.strDueYear}年`;
        labelDueTime += `${this.c_objStrDueEndTime.strDueMonth}月`;
        labelDueTime += `${this.c_objStrDueEndTime.strDueDate}日`;
        labelDueTime += `${this.c_objStrDueEndTime.strDueHour}:`;
        labelDueTime += `${this.c_objStrDueEndTime.strDueMinute} 支付尾款`;
      }
      return labelDueTime;
    },

    c_isNeedCI() {
      return !this.ms_isDebug && this.c_isCourse && !this.c_isQianRenCourse && !this.c_isSaCourse;
    },

    c_isShowCilinkAndDiscountLockpricePresellInfo() {
      return this.c_isCourse || this.c_isCategorySourcePG;
    },

    c_isCloseCiDisabled() {
      return !this.isAgreedLegal;
    },

    c_isOldStu() {
      return this.mg_userInfo.hasPay;
    },

    c_isDiscountNotShown() {
      return this.c_isPresellDepositPage;
    },

    c_isDiscountReadOnlyPage() {
      return this.c_isNormalTradePage || this.c_isLockpriceTradePage;
    },

    c_isDiscountLockedTradePage() {
      return this.c_isDiscountReadOnlyPage || this.c_isPresellDepositTradePage;
    },

    c_encoreInfo() {
      if (this.ms_order.myEncoreCouponCodes && this.ms_order.myEncoreCouponCodes.length > 0) {
        return this.ms_order.myEncoreCouponCodes[0];
      } else {
        return {};
      }
    },

    c_encore() {
      return this.c_encoreInfo.couponCode ? this.c_encoreInfo.couponCode : '';
    },

    c_isShowEncore() {
      if (this.c_isGoodActivity && !this.c_goodActivity.canUseEncore) {
        return false;
      } else if (this.ms_order.encoreValided && this.c_encore) {
        return true;
      } else {
        return false;
      }
    },

    c_isShowEncoreDescription() {
      return this.c_isShowEncore && this.ms_order.encoreValided;
    },

    c_isShowPoint() {
      if (this.c_isGoodActivity) {
        return this.c_goodActivity.canUsePoint;
      } else {
        return this.ms_order.canUsePoint;
      }
    },

    c_pointsMoneyString() {
      if (this.c_isLockpriceTradePage) {
        return this.c_depositAndBalanceModel.usedPoints > 0
          ? '-' + this.c_depositAndBalanceModel.pointsMoneyString
          : this.c_depositAndBalanceModel.pointsMoneyString;
      } else {
        return this.ms_order.pointsMoney > 0
          ? '-' + this.ms_order.pointsMoneyString
          : this.ms_order.pointsMoneyString;
      }
    },

    c_isShowCoupon() {
      if (this.c_isGoodActivity) {
        return this.c_goodActivity.canUseCoupon;
      } else {
        return true;
      }
    },

    c_isBenifitCodeSelected() {
      return Boolean(this.benefitCode);
    },

    c_benifitCodeMoney() {
      if (this.c_isLockpriceTradePage) {
        return this.c_depositAndBalanceModel.couponPrice > 0
          ? '-' + this.c_depositAndBalanceModel.couponCodeMoneyString
          : this.c_depositAndBalanceModel.couponCodeMoneyString;
      } else if (this.c_isNormalTradePage) {
        return this.ms_order.couponMoney > 0
          ? '-' + this.ms_order.couponCodeMoneyString
          : this.ms_order.couponCodeMoneyString;
      } else {
        return this.benifitCodeMoney;
      }
    },

    c_isShowReferenceCode() {
      if (this.c_isHasQHGoods) {
        return false;
      } else if (this.c_isGoodActivity && !this.c_goodActivity.canUseReferenceCode) {
        return false;
      } else if (this.ms_order.newUser && !this.ms_order.wechatSell) {
        return true;
      } else {
        return false;
      }
    },

    c_isReferralCodeSelected() {
      return Boolean(this.referalCode);
    },

    c_isReferalCodeHalfFilled() {
      return 5 !== this.referalCode.length && 0 !== this.referalCode.length;
    },

    c_referalCodeMoney() {
      if (this.c_isLockpriceTradePage) {
        return this.c_depositAndBalanceModel.referCodePrice > 0
          ? '-' + this.c_depositAndBalanceModel.refCodeMoneyString
          : this.c_depositAndBalanceModel.refCodeMoneyString;
      } else if (this.c_isNormalTradePage) {
        return this.ms_order.refMoney > 0
          ? '-' + this.ms_order.refCodeMoneyString
          : this.ms_order.refCodeMoneyString;
      } else {
        return this.referalCodeMoney;
      }
    },

    c_forFree() {
      return this.ms_order.realPrice == 0;
    },

    c_isFromWechatNotMpGood() {
      return this.fromwechat && !this.mpGoodsId;
    },

    _c_isPayCourseDisabled() {
      return this.c_isCourse && (this.ms_isRequestCheck || this.ms_isRequestCouponList);
    },

    c_isCheckResultFailed() {
      return this.checkResult < 0;
    },

    c_isNeedDepositNoRefund() {
      return this.c_isDepositPage && !this.c_isGoodActivityRefund;
    },

    c_isNotAgreedDepositNoRefund() {
      return this.c_isNeedDepositNoRefund && !this.isAgreedDeposit;
    },

    //c_realPriceString() {
    //  if (this.c_isLockpricePresellTradePage) {
    //    return this.c_depositAndBalanceModel.realPriceString;
    //  } else {
    //    return this.ms_order.realPriceString;
    //  }
    //},

    c_totalPrice() {
      return this.ms_order.realPrice;
    },

    c_totalPriceString() {
      return this.ms_order.realPriceString;
    },

    c_isNeedAddress() {
      return this.ms_order.needAddress;
    },

    c_isShowReadOnlyAddress() {
      return this.c_isTradePage && this.ms_order.selectedAddress;
    },

    c_isAddressNotSelected() {
      return this.c_isNeedAddress && this.c_selectedStudentAddressId <= 0;
    },

    c_isShowFqPayType() {
      return 100 < this.c_totalPrice;
    },

    c_payType() {
      if ('zhifubao' === this.payType || 'huabei' === this.payType) {
        return 'alipay';
      } else {
        return this.payType;
      }
    },

    c_isFq() {
      return 'huabei' === this.payType || 'haier' === this.payType;
    },

    c_fq() {
      if (this.c_isFq) {
        return this.fq;
      } else {
        return 0;
      }
    },

    c_isPayTypeDisabled() {
      return '' === this.payType || (this.c_isFq && 0 === this.fq);
    },

    c_isPayDisabled() {
      return (
        this.ms_isRequest ||
        this.ms_order.studentBuyLimit ||
        this._c_isPayCourseDisabled ||
        this.c_isReferalCodeHalfFilled ||
        this.c_isCheckResultFailed ||
        this.c_isNotAgreedDepositNoRefund ||
        //this.c_isAddressNotSelected ||
        this.paplSubmitting ||
        this.isCheckStatusShouldSetTo2
      );
    },

    c_isPayAndPayTypeDisabled() {
      return this.c_isPayDisabled || (!this.c_forFree && this.c_isPayTypeDisabled);
    },

    c_isWechatPay() {
      return 'wechat' === this.payChannel;
    },

    c_isHaierPay() {
      return 'haier' === this.payType;
    },

    c_isMaxCapacityCheck() {
      return true === this.ms_order.maxCapacityCheck;
    },

    c_isMaxCapacityCheckLeft() {
      if (this.c_isMaxCapacityCheck) {
        return this.ms_order.maxCapacity - this.ms_order.numOfStudent;
      } else {
        return 0;
      }
    },

    c_isMaxCapacityCheckSoldOut() {
      return this.c_isMaxCapacityCheck && 0 === this.c_isMaxCapacityCheckLeft;
    },

    c_isEsg_7672() {
      return -1 !== _.indexOf(['7671', '7672', '7673', '7680', '7696'], this.$route.params.goodId);
    },

    c_payloadMakeMallQrcode() {
      return {
        goodsId: this.c_isTradePage ? undefined : this.c_goodId,
        preTradeId: this.c_isTradePage ? this.c_tradeId : undefined,
        encoreCode: this.c_encore,
        refCode: this.referalCode,
        couponCode: this.benefitCode,
        limitYear: this.c_limitYear,
        studentAddressId:
          this.c_selectedStudentAddressId > 0 ? this.c_selectedStudentAddressId : undefined,
        surveyFormId: this.c_surveyFormId,
        vendorId: this.c_vendor_oid,
        studentId: this.c_param4StudentId,
        channelId: this.c_channelId,
      };
    },
  },

  methods: {
    ...mapActions('Mall/Order', {
      ma_getMallGoodQrcode: 'getMallGoodQrcode',
      ma_getMallNormalTradeDetail: 'getMallNormalTradeDetail',
      ma_getMallLockpriceDepositTradeDetail: 'getMallLockpriceDepositTradeDetail',
      ma_getMallPresellDepositTradeDetail: 'getMallPresellDepositTradeDetail',
      ma_getMallLockpriceBalanceTradeDetail: 'getMallLockpriceBalanceTradeDetail',
      ma_getMallPresellBalanceTradeDetail: 'getMallPresellBalanceTradeDetail',
      ma_checkMallGoodQrcode: 'checkMallGoodQrcode',
      ma_makeMallYzQrcode: 'makeMallYzQrcode',
      ma_makeMallNormalTradeQrcode: 'makeMallNormalTradeQrcode',
      ma_makeMallLockpriceDepositTradeQrcode: 'makeMallLockpriceDepositTradeQrcode',
      ma_makeMallPresellDepositTradeQrcode: 'makeMallPresellDepositTradeQrcode',
      ma_makeMallLockpriceBalanceTradeQrcode: 'makeMallLockpriceBalanceTradeQrcode',
      ma_makeMallWechatQrcode: 'makeMallWechatQrcode',
      ma_makeMallNormalTradeWechatQrcode: 'makeMallNormalTradeWechatQrcode',
      ma_makeMallLockpriceDepositTradeWechatQrcode: 'makeMallLockpriceDepositTradeWechatQrcode',
      ma_makeMallPresellDepositTradeWechatQrcode: 'makeMallPresellDepositTradeWechatQrcode',
      ma_makeMallLockpriceBalanceTradeWechatQrcode: 'makeMallLockpriceBalanceTradeWechatQrcode',
      ma_checkMallScanQrcode: 'checkMallScanQrcode',
      ma_checkButtonMallScanQrcode: 'checkButtonMallScanQrcode',
      ma_makeMallPaypalUrl: 'makeMallPaypalUrl',
      ma_makeMallNormalTradePaypal: 'makeMallNormalTradePaypal',
      ma_makeMallLockpriceDepositTradePaypal: 'makeMallLockpriceDepositTradePaypal',
      ma_makeMallPresellDepositTradePaypal: 'makeMallPresellDepositTradePaypal',
      ma_makeMallLockpriceBalanceTradePaypal: 'makeMallLockpriceBalanceTradePaypal',
      ma_makeMallAlipaySnapletHtml: 'makeMallAlipaySnapletHtml',
      ma_makeMallAlipaySnapletTradeHtml: 'makeMallAlipaySnapletTradeHtml',
      ma_makeMallHaierUrl: 'makeMallHaierUrl',
      ma_makeMallHaierLoanTradeUrl: 'makeMallHaierLoanTradeUrl',
      ma_mallAddForFree: 'mallAddForFree',
      ma_getMallCouponList: 'getMallCouponList',
      ma_getMallTradeCouponList: 'getMallTradeCouponList',
    }),

    openCIStep(step, flag) {
      this.ciStep = step;
      $(this.$refs.for_copyright_instruction).modal('show');
      this.hideFooter = Boolean(flag);
    },

    closeCI() {
      $(this.$refs.for_copyright_instruction).modal('hide');
      window.sessionStorage.setItem('ci_read_flag', true);
      this.ciReadFlag = true;
    },

    cancelCI() {
      $(this.$refs.for_copyright_instruction).modal('hide');
      //if (!this.ciReadFlag) {
      if (this.c_isTradePage) {
        this.$router.go(-1);
        return false;
      }
      window.sessionStorage.removeItem('mpGoodsId');
      if (this.fromwechat && this.mpGoodsId) {
        window.sessionStorage.removeItem('fromwechat');
        window.location.href =
          getUrlProtocol() + `mp.pzacademy.com/wx/redirect.html?state=course/${this.mpGoodsId}`;
      }
      if (this.c_isEsg_7672) {
        window.location.href = 'https://www.pzacademy.com/esg-analyst';
      } else {
        this.$router.go(-1);
      }
      //if (this.c_isCpaCourse) {
      //  window.location.href = getUrlProtocol() + `${URL_WWW_PZ_ACADEMY_COM}/mall/cpa`;
      //} else {
      //  if (this.mall_category) {
      //    window.location.href =
      //      getUrlProtocol() +
      //      `${URL_WWW_PZ_ACADEMY_COM}/mall/${this.mall_category}/${this.c_goodId}`;
      //  } else {
      //    window.location.href = getUrlProtocol() + `${URL_WWW_PZ_ACADEMY_COM}/mall`;
      //  }
      //}
      //}
    },

    toCIStep2() {
      this.ciStep = 2;
    },

    //
    getMallGoodQrcode() {
      if (this.c_isTradePage) {
        let getMallTradeDetail = () => null;
        if (this.c_isNormalTradePage) {
          getMallTradeDetail = this.ma_getMallNormalTradeDetail;
        } else if (this.c_isLockpriceDepositTradePage) {
          getMallTradeDetail = this.ma_getMallLockpriceDepositTradeDetail;
        } else if (this.c_isPresellDepositTradePage) {
          getMallTradeDetail = this.ma_getMallPresellDepositTradeDetail;
        } else if (this.c_isLockpriceBalanceTradePage) {
          getMallTradeDetail = this.ma_getMallLockpriceBalanceTradeDetail;
        } else if (this.c_isPresellBalanceTradePage) {
          getMallTradeDetail = this.ma_getMallPresellBalanceTradeDetail;
        }
        return getMallTradeDetail({
          tradeId: this.c_tradeId,
        });
      } else {
        return this.ma_getMallGoodQrcode({
          goodId: this.c_goodId,
          limitYear: this.c_limitYear,
        });
      }
    },

    getMallCouponList() {
      if (this.c_isTradePage) {
        if (!this.c_isDiscountLockedTradePage) {
          return this.ma_getMallTradeCouponList({
            tradeId: this.c_tradeId,
          });
        }
      } else {
        return this.ma_getMallCouponList(this.c_goodId);
      }
    },

    async checkBenefitCode() {
      try {
        await this.ma_checkMallGoodQrcode({
          goodsId: this.c_isTradePage ? undefined : this.c_goodId,
          preTradeId: this.c_isTradePage ? this.c_tradeId : undefined,
          refCode: this.referalCode,
          couponCode: this.benefitCode,
          encoreCode: this.c_encore,
          limitYear: this.c_limitYear,
        });
        this.checkResult = this.ms_checkResult;
        this.checkResultMessage = this.ms_checkResultMessage;
        //if (!this.referalCode) {
        //  this.refBenefit = false;
        //}
      } catch (e) {
        swalWarning('校验失败');
      }
    },

    calcReferralBenefitCodeMoney() {
      let refCodeMoneyString = this.ms_order.refCodeMoneyString;
      this.referalCodeMoney =
        parseFloat(refCodeMoneyString) > 0 ? '-' + refCodeMoneyString : refCodeMoneyString;
      let benifitCodeMoneyString = this.ms_order.couponCodeMoneyString;
      this.benifitCodeMoney =
        parseFloat(benifitCodeMoneyString) > 0
          ? '-' + benifitCodeMoneyString
          : benifitCodeMoneyString;
    },

    async onChange() {
      await this.checkBenefitCode();
      this.calcReferralBenefitCodeMoney();
    },

    handleReferralCodeInput() {
      this.checkResult = 0;
      this.referalCodeMoney = '0.00';
      this.isShowReferalCodeHalfFilled = false;
      if (!this.c_isReferalCodeHalfFilled) {
        this.onChange();
      }
    },

    handleReferralCodeChange() {
      if (this.c_isReferalCodeHalfFilled) {
        this.isShowReferalCodeHalfFilled = true;
      }
    },

    clearReferralCode() {
      this.referalCode = '';
      this.handleReferralCodeInput();
      this.handleReferralCodeChange();
    },

    async handleBenefitCodeChange() {
      this.checkResult = 0;
      if (!this.benefitCode) {
        this.benifitCodeMoney = '0.00';
      }
      await this.onChange();
      if (this.c_isCheckResultFailed) {
        Swal.fire({
          width: '400px',
          icon: 'warning',
          title: this.checkResultMessage,
          confirmButtonColor: '#3085d6',
          confirmButtonText: '确定',
        });
      }
    },

    prevCheck() {
      //if (this.refBenefit /* || (this.useBenefit && this.benefit == '') */) {
      //  //let str = '请正确填写' + (this.ms_order.newUser ? '推荐码/优惠码' : '优惠码');
      //  let str = '请正确填写推荐码';
      //  swalWarning(str);
      //  return false;
      //} /* else if (this.refEncore || (this.useEncore && this.encore == '')) {
      //  swalWarning('请正确填写返场码');
      //  return false;
      //} */ else
      //if (this.c_isPayGoodBuyLimitAndHasPayed) {
      //  Swal.fire({
      //    width: '400px',
      //    icon: 'warning',
      //    title: '您已经购买过该课程，该课程只能购买一次。',
      //    confirmButtonColor: '#3085d6',
      //    confirmButtonText: '确定',
      //  });
      //  return false;
      //} else
      if (this.c_isAddressNotSelected) {
        Swal.fire({
          width: '400px',
          icon: 'warning',
          title: '必须填写邮寄地址哟！',
          confirmButtonColor: '#3085d6',
          confirmButtonText: '确定',
        });
        return false;
      } else {
        return true;
      }
    },

    setPayType(payType) {
      this.payType = payType;
      if ('huabei' === this.payType && 24 === this.fq) {
        this.fq = 0;
      }
    },

    async makeMallYzQrcode() {
      if (this.c_isDiscountLockedTradePage) {
        let makeMallTradeQrcode = async () => null;
        if (this.c_isWechatPay) {
          if (this.c_isNormalTradePage) {
            makeMallTradeQrcode = this.ma_makeMallNormalTradeWechatQrcode;
          } else if (this.c_isLockpriceDepositTradePage) {
            makeMallTradeQrcode = this.ma_makeMallLockpriceDepositTradeWechatQrcode;
          } else if (this.c_isPresellDepositTradePage) {
            makeMallTradeQrcode = this.ma_makeMallPresellDepositTradeWechatQrcode;
          } else if (this.c_isLockpriceBalanceTradePage) {
            makeMallTradeQrcode = this.ma_makeMallLockpriceBalanceTradeWechatQrcode;
          }
        } else {
          if (this.c_isNormalTradePage) {
            makeMallTradeQrcode = this.ma_makeMallNormalTradeQrcode;
          } else if (this.c_isLockpriceDepositTradePage) {
            makeMallTradeQrcode = this.ma_makeMallLockpriceDepositTradeQrcode;
          } else if (this.c_isPresellDepositTradePage) {
            makeMallTradeQrcode = this.ma_makeMallPresellDepositTradeQrcode;
          } else if (this.c_isLockpriceBalanceTradePage) {
            makeMallTradeQrcode = this.ma_makeMallLockpriceBalanceTradeQrcode;
          }
        }
        await makeMallTradeQrcode({
          tradeId: this.c_tradeId,
        });
      } else {
        let makeMallQrcode = async () => null;
        if (this.c_isWechatPay) {
          makeMallQrcode = this.ma_makeMallWechatQrcode;
        } else {
          makeMallQrcode = this.ma_makeMallYzQrcode;
        }
        await makeMallQrcode(this.c_payloadMakeMallQrcode);
      }
      this.checkResult = this.ms_checkResult;
      this.checkResultMessage = this.ms_checkResultMessage;
    },

    async openQrCodeModal() {
      if (!this.prevCheck()) {
        return;
      }
      this.qrType = 2;
      $(this.$refs.orderPopup).modal({
        backdrop: 'static',
        keyboard: false,
      });
      try {
        await this.makeMallYzQrcode();
        if (this.c_isCheckResultFailed) {
          $(this.$refs.orderPopup).modal('hide');
        } else {
          this.srcPayQR = this.ms_imgQr.qrCode;
          this.loop();
        }
      } catch (e) {
        swalWarning('获取二维码失败');
        this.stopLoopCheckQR();
      }
    },

    openYz() {
      this.payChannel = '';
      this.openQrCodeModal();
    },

    openWechatPay() {
      this.payChannel = 'wechat';
      this.openQrCodeModal();
    },

    async checkMallScanQrcode() {
      await this.ma_checkMallScanQrcode({
        qrId: this.ms_imgQr.qrId,
        qrType: this.qrType,
        vendorId: this.c_vendor_oid,
      });
    },

    loop() {
      this.scanLoop = setInterval(async () => {
        this.count++;
        if (this.count == 30) {
          this.stopLoopCheckQR();
        }
        try {
          await this.checkMallScanQrcode();
          if (this.ms_checkScanResult) {
            this.stopLoopCheckQR();
            this.toCheckPage = true;
            this._setCheckStatusTo2();
          }
        } catch (e) {
          this.stopLoopCheckQR();
        }
      }, 4000);
    },

    async checkButtonMallScanQrcode() {
      await this.ma_checkButtonMallScanQrcode({
        qrId: this.ms_imgQr.qrId,
        qrType: this.qrType,
        vendorId: this.c_vendor_oid,
      });
    },

    async checkPay() {
      if (this.c_isHaierPay) {
        this.$router.push('/dashboard');
      } else {
        this.stopLoopCheckQR();
        this.checkStatus = 1;
        this.toCheckPage = true;
        await this.checkButtonMallScanQrcode();
        if (this.ms_checkScanResult) {
          this._setCheckStatusTo2();
        } else {
          this.checkStatus = 3;
        }
      }
    },

    stopLoopCheckQR() {
      this.count = 1;
      clearInterval(this.scanLoop);
    },

    _setCheckStatusTo2() {
      if (!this.isCheckStatusShouldSetTo2) {
        this.isCheckStatusShouldSetTo2 = true;
        this.getStudentAndTutorInfo();
        this.checkStatusNextStep();
      }
    },

    async checkStatusNextStep() {
      if (this.checkStatus < 9 && this.c_isSalesQrCodeNeeded) {
        this.checkStatus = 9;
        return;
      }
      if (this.checkStatus < 10 && this.c_isStep1Needed) {
        this.checkStatus = 10;
        return;
      }
      if (this.c_isActivity) {
        $(this.$refs.orderPopup).modal('hide');
        await swalSuccess('购买成功！');
        await this.promiseGetStudentAndTutorInfo;
        window.location.href = this.ms_order.activityUrl;
      } else if (this.c_isEsg_7672) {
        this.$router.push('/esg-order-completed');
      } else {
        this.checkStatus = 2;
      }
    },

    resetPay() {
      this.checkStatus = 0;
      this.toCheckPage = false;
      this.loop();
    },

    setModalHiddenHandlerOrderPopup() {
      $(this.$refs.orderPopup).on('hidden.bs.modal', () => {
        this.srcPayQR = '';
        this.stopLoopCheckQR();
        this.checkStatus = 0;
        this.toCheckPage = false;
      });
    },

    closeOrderPopup() {
      Swal.fire({
        icon: 'warning',
        width: '600px',
        title: '好价不等人，是否要取消支付？',
        confirmButtonText: '残忍取消',
        showCancelButton: true,
        cancelButtonText: '继续支付',
        customClass: {
          confirmButton: 'btn btn-lg btn-light text-danger mx-3',
          cancelButton: 'btn btn-lg btn-danger mx-3',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          $(this.$refs.orderPopup).modal('hide');
          this.$router.push('/my-order');
        } else {
          return;
        }
      });
    },

    setFq(fq) {
      this.fq = fq;
    },

    async openAliPay() {
      try {
        if (this.c_isTradePage) {
          await this.ma_makeMallAlipaySnapletTradeHtml({
            tradeId: this.c_tradeId,
            fq: this.c_fq ? this.c_fq : undefined,
          });
        } else {
          await this.ma_makeMallAlipaySnapletHtml({
            ...this.c_payloadMakeMallQrcode,
            //snapletType: 'wap', //this.c_isMobile ? 'wap' : 'page',
            fq: this.c_fq ? this.c_fq : undefined,
          });
        }
        $(this.$refs.webAlipayPageSnapletHtml).html(this.ms_webAlipayPageSnapletHtml);
      } catch (e) {
        swalWarning('支付失败');
      }
    },

    async openHaierPay() {
      try {
        if (this.c_isTradePage) {
          await this.ma_makeMallHaierLoanTradeUrl({
            tradeId: this.c_tradeId,
            fq: this.c_fq ? this.c_fq : undefined,
          });
        } else {
          await this.ma_makeMallHaierUrl({
            ...this.c_payloadMakeMallQrcode,
            fq: this.c_fq ? this.c_fq : undefined,
          });
        }
        $(this.$refs.orderPopup).modal({
          backdrop: 'static',
          keyboard: false,
        });
        this.srcPayQR = await QRCode.toDataURL(this.ms_webHaierUrl, { errorCorrectionLevel: 'L' });
      } catch (e) {
        swalWarning('支付失败');
      }
    },

    paypalPrev() {
      if (!this.prevCheck()) {
        return;
      }
      $(this.$refs.forPaypalPrev).modal('show');
    },

    showPaplOverlay() {
      this.paplQueue.push({});
      if (this.paplQueue.length === 1) {
        this.paplTimerPromise = setTimeout(() => {
          if (this.paplQueue.length) this.paplSubmitting = true;
        }, 300);
      }
    },

    hidePaplOverlay() {
      this.paplQueue.pop();
      if (this.paplQueue.length == 0) {
        this.paplTimerPromiseHide = setTimeout(() => {
          if (this.paplQueue.length === 0) {
            this.paplSubmitting = false;
            if (this.paplTimerPromiseHide) clearTimeout(this.paplTimerPromiseHide);
          }
        }, 300);
      }
    },

    async makeMallPaypalUrl() {
      if (this.c_isDiscountLockedTradePage) {
        let makeMallTradePaypal = async () => null;
        if (this.c_isNormalTradePage) {
          makeMallTradePaypal = this.ma_makeMallNormalTradePaypal;
        } else if (this.c_isLockpriceDepositTradePage) {
          makeMallTradePaypal = this.ma_makeMallLockpriceDepositTradePaypal;
        } else if (this.c_isPresellDepositTradePage) {
          makeMallTradePaypal = this.ma_makeMallPresellDepositTradePaypal;
        } else if (this.c_isLockpriceBalanceTradePage) {
          makeMallTradePaypal = this.ma_makeMallLockpriceBalanceTradePaypal;
        }
        await makeMallTradePaypal({
          tradeId: this.c_tradeId,
        });
      } else {
        await this.ma_makeMallPaypalUrl(this.c_payloadMakeMallQrcode);
      }
    },

    async paypal() {
      $(this.$refs.forPaypalPrev).modal('hide');
      this.showPaplOverlay();
      try {
        await this.makeMallPaypalUrl();
        if (this.ms_paypalURL) {
          if (this.c_vendor_oid) {
            window.sessionStorage.setItem('vendor_oid', this.c_vendor_oid);
          }
          window.location.href = this.ms_paypalURL;
        }
      } catch (e) {
        swalWarning('paypal付款出现问题');
        this.hidePaplOverlay();
      }
    },

    paypalPrevClose() {
      $(this.$refs.forPaypalPrev).modal('hide');
    },

    pay() {
      if (!this.prevCheck()) {
        return;
      }
      if ('yz' === this.c_payType) {
        this.openYz();
      } else if ('paypal' === this.c_payType) {
        this.paypalPrev();
      } else if ('alipay' === this.c_payType) {
        this.openAliPay();
      } else if ('wechat' === this.c_payType) {
        this.openWechatPay();
      } else if ('haier' === this.c_payType) {
        this.openHaierPay();
      }
    },

    toAddForFree() {
      if (!this.prevCheck()) {
        return;
      }
      if (this.c_isCategorySourcePG) {
        this.addForFreeStatus = 0;
        $(this.$refs.pgPopup).modal({ backdrop: true, show: true });
      } else {
        this.addForFreeStatus = 0;
        $(this.$refs.addForFreePopup).modal({ backdrop: true, show: true });
      }
    },

    toAddForTaobao() {
      $(this.$refs.addForFreePopup).modal({ backdrop: true, show: true });
      this.addForFree();
    },

    //
    async addForFree() {
      this.addForFreeStatus = 2;
      try {
        await this.ma_mallAddForFree(this.c_payloadMakeMallQrcode);
        if (1 === this.ms_checkResult) {
          this.getStudentAndTutorInfo();
          this.addForFreeStatusNextStep();
        } else {
          this.addForFreeStatus = -1;
        }
      } catch (e) {
        this.addForFreeStatus = -1;
      }
    },

    closeAddForFreePopup() {
      if (this.c_isCategorySourcePG) {
        $(this.$refs.pgPopup).modal('hide');
      } else {
        $(this.$refs.addForFreePopup).modal('hide');
      }
    },

    gotoDashboard() {
      window.sessionStorage.removeItem('mpGoodsId');
      if (this.c_isFromWechatNotMpGood) {
        return;
      }
      if (this.fromwechat && this.mpGoodsId) {
        window.sessionStorage.removeItem('fromwechat');
        window.location.href =
          getUrlProtocol() + `mp.pzacademy.com/wx/redirect.html?state=mymini-list`;
      }
      this.$router.push(DASHBOARD_PAGE);
    },

    ///
    closeAddressEdit() {
      this._closeAddressEdit();
      if (this.c_isNeedAddress && this.c_isHaveAddressOnlyOne) {
        this.strSelectedStudentAddressId = '' + this.mg_myAddresses[0].studentAddressId;
      }
    },

    openDetailExcel() {
      if (!this.ms_order.studyPlanDoc) {
        swalWarning('学习计划更新中');
        return;
      }
      window.open(this.ms_order.studyPlanDoc, '_blank');
    },

    openVideo() {
      $(this.$refs.for_entry_video).modal('show');
      if (!this.player) {
        this.player = window.polyvPlayer({
          wrap: '#entry_plv',
          width: '100%',
          height: '100%',
          vid: '379c2a7b332ab5cfdf0577b8552d9d46_3',
          //playsafe: ''
        });
      }
      //if (!this.player) {
      //  this.player = window.polyvObject('#entry_plv').videoPlayer({
      //    width: '100%',
      //    height: '100%',
      //    vid: '379c2a7b332ab5cfdf0577b8552d9d46_3',
      //    flashvars: {
      //      setVolumeM: '1.2',
      //    },
      //  });
      //} else if (this.player && this.player.changeVid) {
      //  this.player.changeVid('379c2a7b332ab5cfdf0577b8552d9d46_3');
      //}
    },

    openDetailPdf() {
      window.open(this.ms_order.newJoinerDoc, '_blank');
    },

    async _OrderCreated() {
      if (this.c_isMobile || this.c_isWechatBrowser) {
        if (URL_CLASS_PZ_ACADEMY_COM === window.location.host) {
          window.location.href = window.location.href.replace(
            `${URL_CLASS_PZ_ACADEMY_COM}/order`,
            'msite.pzacademy.com/order'
          );
          return;
        }
      }
      if (this.c_isFromChannel) {
        this.$router.push(
          `/write-off/${this.$route.params.goodId}?source=${this.$route.query.source}`
        );
        return false;
      }
      this.ma_getUserInfo();
      this.fromwechat = window.sessionStorage.getItem('fromwechat');
      this.promiseGetMallCouponList = this.getMallCouponList();
      this.promiseGetMallGoodQrcode = this.getMallGoodQrcode();
      await this.promiseGetMallGoodQrcode;
      if (this.ms_order) {
        this.mpGoodsId = this.ms_order.mpGoodsId;
        if (this.ms_order.mpGoodsId) {
          window.sessionStorage.setItem('mpGoodsId', this.ms_order.mpGoodsId);
        }
        window.sessionStorage.setItem('order_category', this.ms_order.category);
        window.sessionStorage.setItem('order_activityUrl', this.ms_order.activityUrl);
        if (this.c_isStep1Needed) {
          window.sessionStorage.setItem('isStep1Needed', 'true');
        }
        if (this.c_isSalesQrCodeNeeded) {
          window.sessionStorage.setItem('salesQrCode', this.ms_order.salesQrCode);
        }
        let encoreDescription = this.ms_order.encoreDescription;
        if (encoreDescription) {
          encoreDescription = encoreDescription.split('|');
          this.encoreDescription1 = encoreDescription[0];
          this.encoreDescription2 = encoreDescription[1];
        }
        if (this.c_isGoodActivity) {
          this.countdownId = countdown(
            (timeSpan) => {
              this.timeSpan = timeSpan;
            },
            this.c_goodActivity.endTime,
            countdown.DAYS | countdown.HOURS | countdown.MINUTES | countdown.SECONDS
          );
        }
        if (this.c_isShowReadOnlyAddress) {
          this.strSelectedStudentAddressId = '' + this.ms_order.selectedAddress;
        } else if (this.c_isNeedAddress && this.c_isHaveAddress) {
          this.strSelectedStudentAddressId = '' + this.mg_myAddresses[0].studentAddressId;
        }
        this.setGiftsList();
      }
    },

    async _OrderMounted() {
      if (this.c_isFromChannel) {
        return false;
      }
      this.ciReadFlag = window.sessionStorage.getItem('ci_read_flag');
      //this.mall_category = window.sessionStorage.getItem('mall_category');

      this.setModalHiddenHandlerOrderPopup();

      await this.promiseGetMallGoodQrcode;

      if (this.ms_order && this.ms_order.studentBuyLimit) {
        await Swal.fire({
          icon: 'warning',
          backdrop: 'static',
          keyboard: false,
          title: '温馨提示',
          text: this.ms_order.studentBuyLimitMessage,
          confirmButtonColor: '#3085d6',
          confirmButtonText: '确定',
        }).then((result) => {
          if (result.value) {
            if (this.c_isCourse) {
              if (this.c_isEsg_7672) {
                window.location.href = 'https://www.pzacademy.com/mall/esg';
              } else {
                this.$router.go(-1);
              }
              return;
            }
            if (this.c_isCoupon) {
              this.$router.push(MALL_CATEGORY_COUPON_PAGE);
              return;
            }
          }
        });
      }

      if (/* !this.ciReadFlag && */ this.c_isNeedCI) {
        this.openCIStep(2);
        if (URL_CLASS_PZ_ACADEMY_COM === window.location.host) {
          document.domain = 'pzacademy.com';
          this.itvlLegal = setInterval(() => {
            const $legal = $('#order-legal');
            const thisheight = $legal.contents().find('body').height() + 100;
            $legal.height(thisheight < 500 ? 500 : thisheight);
          }, 100);
        }
      }

      await this.promiseGetMallCouponList;
      if (!this.c_isDiscountReadOnlyPage && 1 <= this.ms_couponList.length) {
        this.benefitCode = this.ms_couponList[0].couponCode;
        this.handleBenefitCodeChange();
      }
    },

    _OrderBeforeDestroy() {
      $(this.$refs.orderPopup).modal('hide');
      $(this.$refs.addForFreePopup).modal('hide');
      this.stopLoopCheckQR();
      if (this.c_isGoodActivity) {
        clearInterval(this.countdownId);
      }
      if (/* !this.ciReadFlag && */ this.c_isNeedCI) {
        if (URL_CLASS_PZ_ACADEMY_COM === window.location.host) {
          document.domain = URL_CLASS_PZ_ACADEMY_COM;
          clearInterval(this.itvlLegal);
        }
      }
    },
  },

  created() {
    this._OrderCreated();
  },

  mounted() {
    window.scrollTo(0, 0);
    this._OrderMounted();
  },

  beforeDestroy() {
    this._OrderBeforeDestroy();
  },
};
